import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/calendar-2.svg'
import _imports_1 from '@/assets/icons/clock-2.svg'


const _withScopeId = n => (_pushScopeId("data-v-64f12ce7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-mt-8 tw-bg-white tw-rounded-[14px] tw-text-left tw-p-[20px] tw-text-darkBlue tw-font-weight-medium c-card" }
const _hoisted_2 = { class: "tw-flex tw-gap-y-3 flex-column tw-items-start rmd:!tw-flex-row rmd:!tw-justify-between tw-mb-[20px]" }
const _hoisted_3 = { class: "tw-text-[20px] rmd:tw-text-[24px] tw-text-darkBlue tw-font-bold tw-text-left" }
const _hoisted_4 = { class: "tw-flex tw-gap-3 rmd:!tw-gap-[35px] tw-mb-[25px] tw-flex-col rmd:!tw-items-center rmd:!tw-flex-row" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-gap-[12px]" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "tw-max-w-[20px]"
}, null, -1))
const _hoisted_7 = { class: "tw-flex tw-items-center tw-gap-[12px]" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "tw-max-w-[20px]"
}, null, -1))
const _hoisted_9 = { class: "tw-grid tw-grid-cols-[32px_1fr] tw-gap-[10px] tw-items-center" }
const _hoisted_10 = { class: "tw-rounded-full tw-overflow-hidden tw-w-[30px] tw-h-[30px] tw-relative" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "tw-font-semibold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-opacity-50 tw-ml-1 tw-text-[14px]" }, "(Trade Person)", -1))

import { PROJECT_STORE } from "@/store/modules/project";
import { CallTypesEnums } from "@/core/enums/VideoEnum";
import { getImageStringToImageURL } from "@/core/utils/common";
import DailyIframe from "@daily-co/daily-js";
import MeetingNotCreated from "@/modules/project/modal/MeetingNotCreated.vue";
import moment from "moment";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { onBeforeMount } from "vue";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import VideoService from "@/core/services/video.service";
import { JOBS_STORE } from "@/store/modules/jobs";
import { onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoConsultationPage',
  props: {
  projectDetails: {
    type: Object,
  },
},
  setup(__props) {

const route = useRoute();
const store = useStore();
const router = useRouter();
const videoConsultationStatus = ref("idel");
const callFrameRef = ref<HTMLElement | null>(null);
let callFrame: any = null;

const props = __props as any;

const isAllowToJoinMeeting = ref(true);

const userUrl = ref(null);

const isDisableCreateRoomButton = ref(false);

const isLoading = ref(false);

const isShowMeetingNotCreatedModal = ref(false);

const isMeetingOnGoing = ref(false);

const participantsCount = ref(0);

const startCall = async () => {
  if (!callFrame) {
    callFrame = DailyIframe.createFrame(callFrameRef.value as HTMLElement, {
      iframeStyle: {
        height: "100%",
        width: "100%",
        border: "1px solid var(--grey)",
        borderRadius: "4px",
      },
      showLeaveButton: true,
    });

    callFrame.on("left-meeting", leaveCall);
    callFrame.on("participant-joined", handleParticipantStateChange);
    callFrame.on("participant-left", handleParticipantStateChange);
    let response;
    try {
      isLoading.value = true;
      response = await store.dispatch(
        `${JOBS_STORE}/getVideoConsultationRoomUrl`,
        {
          roomTitle: route.params?.refId,
          type: CallTypesEnums.MEETING,
          // startDate: moment(videoScheduleDetails.value[0].startDate).format(
          //   "YYYY-MM-DD"
          // ),
          // startTime: videoScheduleDetails.value[0].startTime,
          // endTime: videoScheduleDetails.value[0].endTime,
        }
      );
    } catch (error) {
      videoConsultationStatus.value = "incall";
      isShowMeetingNotCreatedModal.value = true;
      response = null;
      onClickLeaveButton();
    } finally {
      isLoading.value = false;
    }

    console.log(response);
    if (response?.url) {
      videoConsultationStatus.value = "incall";

      callFrame
        .join({ url: response?.url, token: response?.token })
        .then(() => {
          isMeetingOnGoing.value = true;
        })
        .catch((error: any) => {
          if (error?.error?.type === "nbf-room") {
            isAllowToJoinMeeting.value = false;
          }
          console.error("Failed to join the call:", error);
        });
    }
  }
};

const handleParticipantStateChange = () => {
  const participants = callFrame.participants();
  participantsCount.value = Object.keys(participants).length;
};

const leaveCall = async () => {
  if (callFrame && isAllowToJoinMeeting.value) {
    videoConsultationStatus.value = "idel";
    callFrame.leave().catch((error: any) => {
      console.error("Failed to leave the call:", error);
    });
    callFrame.destroy();
    callFrame = null;
    isMeetingOnGoing.value = false;
    if (participantsCount.value === 1 || participantsCount.value === 0) {
      await VideoService.deleteRoom(route.params?.refId);
    }
  }
};

const closeModal = () => {
  isShowMeetingNotCreatedModal.value = false;
  router.go();
};

const onClickLeaveButton = () => {
  videoConsultationStatus.value = "idel";
  callFrame.leave().catch((error: any) => {
    console.error("Failed to leave the call:", error);
  });
  callFrame.destroy();
  callFrame = null;
  isMeetingOnGoing.value = false;
};

const getVideoStartedDate = (videoStartDate: string) => {
  return moment(videoStartDate).format("D MMMM YYYY");
};
const getFormateTime = (time: string) => {
  return moment(time, "HH:mm").format("hh:mm A");
};
const getProjectEstimateDataWithEscrow = computed(
  () => store.getters[`${PROJECT_STORE}/getProjectEstimateDataWithEscrow`]
);
const firstEstimatePhaseDetails = computed(
  () => getProjectEstimateDataWithEscrow?.value?.estimationPhase[0]
);
const setUserWsImage = async () => {
  userUrl.value = await getImageStringToImageURL(
    getProjectEstimateDataWithEscrow.value?.workStation?.profileImage
  );
};
onBeforeMount(async () => {
  await setUserWsImage();
});

onUnmounted(() => {
  if (callFrame) {
    callFrame.off("participant-joined", handleParticipantStateChange);
    callFrame.off("participant-left", handleParticipantStateChange);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(props.projectDetails.name), 1)
        ]),
        (!isMeetingOnGoing.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "button button-purple button-join",
              onClick: startCall,
              loading: isLoading.value,
              disabled: isDisableCreateRoomButton.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Join meeting")
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true),
        (isMeetingOnGoing.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              class: "button button-purple button-ongoing",
              disabled: true
            }, {
              default: _withCtx(() => [
                _createTextVNode("Ongoing")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", null, _toDisplayString(getVideoStartedDate(firstEstimatePhaseDetails.value?.phaseStartDate)), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", null, _toDisplayString(getFormateTime(firstEstimatePhaseDetails.value?.startTime)) + " - " + _toDisplayString(getFormateTime(firstEstimatePhaseDetails.value?.endTime)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (userUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: userUrl.value,
                alt: "",
                class: "tw-absolute tw-top-0 tw-left-0 tw-h-full tw-w-full tw-object-cover"
              }, null, 8, _hoisted_11))
            : (_openBlock(), _createBlock(UserProfileLogo, {
                key: 1,
                userName: getProjectEstimateDataWithEscrow.value?.workStation?.name
              }, null, 8, ["userName"]))
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("strong", _hoisted_12, _toDisplayString(getProjectEstimateDataWithEscrow.value?.workStation?.name), 1),
          _hoisted_13
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "callFrameRef",
      ref: callFrameRef,
      class: "call-frame"
    }, [
      (!isAllowToJoinMeeting.value)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            variant: "text",
            class: "leave-button",
            "prepend-icon": "mdi-logout",
            onClick: onClickLeaveButton
          }, {
            default: _withCtx(() => [
              _createTextVNode("Leave")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, videoConsultationStatus.value === 'incall']
    ]),
    (isShowMeetingNotCreatedModal.value)
      ? (_openBlock(), _createBlock(MeetingNotCreated, {
          key: 0,
          onCloseModal: closeModal
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})